import { BetsQueryKeys } from '@/api/bets/queryKey';
import { DetailedBet } from '@/models/detailed-bet';
import { GenericError } from '@/models/generic-error';
import { PaginatedResponse } from '@starsoft/common/models';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { UseBetRankingProps, UseBetRankingQueryKeyProps } from './props';
import { fetchBetsRanking } from './service';

import { BetRankingFilterQuery } from '@/services/dto/bet/ranking/bet-ranking-filter-query.dto';
import { usePaginatedQuery } from '@starsoft/common/hooks';

export function useBetRanking(options?: UseBetRankingProps) {
  const { periodId, typeId, limit, query, gameId } = options;

  const [page, setPage] = useState<number>(1);

  const filter: BetRankingFilterQuery = {
    page,
    limit: limit ?? 15,
    query,
    periodId,
    typeId,
    gameId,
  };

  const queryKey: UseBetRankingQueryKeyProps = [BetsQueryKeys.Ranking, filter];

  const { data, isPending, fetchStatus, error, refetch, isFetching } = useQuery<
    PaginatedResponse<DetailedBet>,
    AxiosError<GenericError>,
    PaginatedResponse<DetailedBet>,
    UseBetRankingQueryKeyProps
  >({
    queryFn: fetchBetsRanking,
    queryKey,
    staleTime: 5 * 1000,
    enabled: !!periodId && !!typeId,
  });

  const paginatedCallbacks = usePaginatedQuery({
    data,
    page,
    setPage,
    queryParams: {
      periodId,
      typeId,
      gameId,
      query,
    },
  });

  return {
    isPending: (isPending || isFetching) && fetchStatus !== 'idle',
    error,
    refetch,
    data,
    ...paginatedCallbacks,
    page,
  };
}
